
function toSpotifyEmbedUrl(url: string): string {
    const regex =
        /^https?:\/\/(?:open|play)\.spotify\.com\/(track|album|playlist|artist|show|episode)\/([a-zA-Z0-9]+)/
    const match = url.match(regex)
    if (!match) return ''
    const [, type, id] = match
    return `https://open.spotify.com/embed/${type}/${id}`
}

export default function SpotifyEmbed({ spotifyUrl, ...props }: { spotifyUrl: string } & React.HTMLAttributes<HTMLIFrameElement>) {
    const embedUrl = toSpotifyEmbedUrl(spotifyUrl)

    return (
        <iframe
            title="Spotify Embed"
            className="h-full w-full"
            src={embedUrl}
            {...props}
        />
    )
}
